<!-- <mat-list-item class="title-list-item" (click)="titlePressed()">

  <div matRipple [matRippleUnbounded]="false" class="padding title-container d-flex fd-row jc-between ai-center">

    <p class="title">
      <mat-icon class="flex-1 icon">menu</mat-icon> {{ filters?.name || 'No Selected Filters' }}
    </p>


    <button class="save-button" *ngIf="filters" mat-flat-button color="primary" [disabled]="filters._id"
      (click)="saveFilters.emit($event); $event.stopImmediatePropagation(); $event.stopPropagation(); false">Save</button>

  </div>

</mat-list-item> -->
<div
  class="filters-title-container flex-1 d-flex fd-row jc-between ai-stretch"
>
  <div
    class="filters-name-container basis-50 d-flex fd-row ai-stretch"
  >
    <mat-icon>filter_alt</mat-icon>
    <span class="filters-name">{{
      filters?.name || "No Selected Filters"
    }}</span>
  </div>
  <button
    class="switch-filters-button basis-160"
    mat-button
    (click)="titlePressed()"
  >
    <div class="d-flex fd-row jc-between ai-center">
      <div class="d-flex ai-center">
        <span class="filters-name">Switch filters</span>
        <span
          *ngIf="filters && !filters._id && !autoSave"
          class="unsaved-star"
          matTooltip="Unsaved Changes"
          >*</span
        >
      </div>

      <mat-icon>chevron_right</mat-icon>
    </div>
  </button>
</div>
